import { createGlobalStyle } from "styled-components"
import Color from "./commons/Color"

export default createGlobalStyle`

  body {
    margin: 0;
		padding: 0;
  }

	/*** Others ***/
	.spinner-container {
		height: 70vh;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	/*** Paddings ***/
	.common-padding {
		padding: 16px !important;
	}

	/*** Overwrite Ant Design input styles ***/
	.ant-form label {
    font-size: 12px !important;
		font-weight: 600;
	}
	/*** Modal ***/
	.ant-modal {
		max-width: 900px;
		width: 100% !important;
		.ant-modal-body {
			padding: 0;
		}
		.ant-modal-content {
			border-radius: 16px;
		}
	}
	.ant-modal-mask {
		background-color: rgba(47, 137, 252, 0.8) !important;
	}
	/*** Form ***/
	.ant-form-item {
		margin-bottom: 0 !important;
	}
	.double-input-container {
		display: flex;
	}
	.form-title-divider {
		border-bottom: 1px solid ${ Color.main };
		margin: 32px 0;
	}
	.double-input-container {
		display: flex;
		flex-direction: row;
		.ant-form-item {
			margin-right: 16px;
		}
	}

	.paginator-container {
		margin: 32px 0;
	}
	
`